import React from 'react';
import Table from '../Table';
import { PreviewBaseProps } from '../PreviewContents';

/**
 * プレビュー画面中カテゴリのProps定義
 */
export type PreviewCategoryHeaderProps = PreviewBaseProps;

/**
 * プレビュー画面 小カテゴリヘッダーコンポーネント
 *
 * ※必ずTableタグ内で使用して下さい
 */
const PreviewSmallCategoryHeader = ({ title, uniqueId }: PreviewCategoryHeaderProps) => {
  return (
    <Table.Tr>
      <Table.Td colSpan={2} className='preview-table__category headline-5 u-pt12' data-testid={uniqueId} data-testid-e2e={uniqueId}>
        <p>{title}</p>
      </Table.Td>
    </Table.Tr>
  );
};

export default PreviewSmallCategoryHeader;
